import React, { FC } from 'react';
import styled from 'styled-components';

import { Methods, SaveBankCardMethod } from '~/api/finance/financeApiTypes';
import { TextSmallStyle } from '~/atomic/Typography';
import { unLinkBankCard } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.data';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { useAppDispatch, useAppSelector } from '~/store';

import { DefaultMethodPaymentParams, MethodPaymentTemplate } from '../MethodPaymentTemplate';
import { SaveBankCardMethodPaymentIcon } from './SaveBankCardMethodPaymentIcon';

interface SaveBankCardMethodPaymentProps extends DefaultMethodPaymentParams {
  method: SaveBankCardMethod;
}

export const SaveBankCardMethodPayment: FC<SaveBankCardMethodPaymentProps> = ({
  method,
  onCheck,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const { activeMethod } = useAppSelector(choosePaySelector);

  const deleteSaveCardHandler = (e) => {
    e.stopPropagation();
    dispatch(unLinkBankCard({ bankCardId: method.card.id }));
  };

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCSaveBankCardMethodPaymentIcon />
      )}
      Text={method.card.number}
      Bottom={(
        <SCDeleteCardWrapper>
          <SCDeleteCard
            onClick={deleteSaveCardHandler}
          >
            Удалить
          </SCDeleteCard>
        </SCDeleteCardWrapper>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck({
            ...method,
            type: Methods.bankCard,
          });
        }
      }}
      {...props}
    />
  );
};

const SCSaveBankCardMethodPaymentIcon = styled(SaveBankCardMethodPaymentIcon)`
  width: 35px;
  height: 35px;
  fill: var(--black-color);

  &[data-is-disabled="true"] {
    fill: var(--gray-color);
  }
`;

const SCDeleteCard = styled.div`
  text-decoration: underline;
  margin-top: 8px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

const SCDeleteCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${TextSmallStyle};
  color: var(--gray-color);
`;
